import { stripHtmlTags } from '@change-corgi/core/html';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useNewsAndGuidesDetailsPageData } from 'src/app/pages/newsAndGuides/details/pageContext';

type Result = ModelHookResult<{
	title: string;
	description: string;
	photo?: {
		url: string;
		width: number;
		height: number;
	};
}>;

export function usePageMeta(): Result {
	const {
		data: {
			details: { title, excerpt, media },
		},
	} = useNewsAndGuidesDetailsPageData();
	const { resolveUrl } = useUtilityContext();

	const photo = media?.sizes.medium;

	return {
		data: {
			title,
			description: stripHtmlTags(excerpt).trim(),
			photo: photo
				? {
						...photo,
						url: resolveUrl(photo.url),
					}
				: undefined,
		},
	};
}
